(() => {
  'use strict';
  const root = document.querySelector('[data-lp]');
  if (!root) return;
  const q = (s, r = root) => r.querySelector(s);
  const qa = (s, r = root) => [...r.querySelectorAll(s)];

  // Gallery: arrows, thumbs and swipe.
  const slides = qa('[data-lp-slide]');
  const thumbs = qa('[data-lp-thumb]');
  let cur = 0;
  const show = i => {
    cur = (i + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('is-on', k === cur));
    thumbs.forEach((t, k) => t.setAttribute('aria-pressed', String(k === cur)));
    thumbs[cur]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };
  q('[data-lp-prev]')?.addEventListener('click', () => show(cur - 1));
  q('[data-lp-next]')?.addEventListener('click', () => show(cur + 1));
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
  const main = q('.lp-gallery__main');
  let x0 = null;
  main?.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
  main?.addEventListener('touchend', e => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
    x0 = null;
  });

  // Bundle picker sets the quantity; the 2- and 3-pack prices come from automatic discounts.
  const qty = q('[data-lp-qty]');
  const priceEl = q('[data-lp-price]');
  qa('[name="lp-pack"]').forEach(r => r.addEventListener('change', () => {
    qty.value = r.value;
    if (priceEl) priceEl.textContent = r.dataset.price;
    const was = q('[data-lp-was]'), save = q('[data-lp-save]');
    if (was) was.textContent = r.dataset.was;
    if (save) save.textContent = r.dataset.save;
  }));

  // Add to cart / buy now.
  const form = q('[data-lp-form]');
  const err = q('[data-lp-error]');
  form?.addEventListener('submit', async e => {
    e.preventDefault();
    const now = e.submitter?.hasAttribute('data-lp-now');
    const buttons = qa('button[type=submit]', form);
    buttons.forEach(b => b.setAttribute('aria-busy', 'true'));
    err.hidden = true;
    try {
      const res = await fetch(root.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: Math.max(1, Number(qty.value) || 1) }] }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
      location.assign(root.dataset.root + (now ? 'checkout' : 'cart'));
    } catch (ex) {
      err.textContent = ex.message;
      err.hidden = false;
      buttons.forEach(b => b.removeAttribute('aria-busy'));
    }
  });

  // Glass preview: the real designs from the product photos, shown through a fine LED mesh.
  const canvas = q('[data-lp-canvas]');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    const input = q('[data-lp-input]');
    const speedEl = q('[data-lp-speed]');
    const textbox = q('[data-lp-textbox]');
    const RATIO = 3.6;
    let mode = null, color = 'rwb', t = 0, offset = 0, running = false, last = 0, mesh = null, meshSize = 0;
    const imgs = {};
    const designs = qa('[data-lp-design]');

    const load = btn => {
      const key = btn.dataset.lpDesign;
      if (key === 'text' || imgs[key]) return;
      const im = new Image();
      im.decoding = 'async';
      im.src = btn.dataset.src;
      imgs[key] = { im, crop: btn.dataset.crop.split(',').map(Number) };
    };

    const size = () => {
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      const w = canvas.clientWidth, h = w / RATIO;
      if (canvas.width !== Math.round(w * dpr)) {
        canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); canvas.style.height = h + 'px';
      }
      return dpr;
    };
    const buildMesh = dpr => {
      // Dense LED dots like the photos: a small dark grid with round diodes.
      const s = Math.max(3, Math.round(3.2 * dpr));
      if (mesh && meshSize === s) return;
      meshSize = s;
      const c = document.createElement('canvas'); c.width = c.height = s;
      const m = c.getContext('2d');
      m.fillStyle = 'rgba(0,0,0,.55)'; m.fillRect(0, 0, s, s);
      m.globalCompositeOperation = 'destination-out';
      m.beginPath(); m.arc(s / 2, s / 2, s * 0.36, 0, Math.PI * 2); m.fill();
      mesh = ctx.createPattern(c, 'repeat');
    };
    const finish = (W, H) => {
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.fillStyle = mesh; ctx.fillRect(0, 0, W, H);
      const g = ctx.createLinearGradient(0, 0, W * 0.7, H);
      g.addColorStop(0, 'rgba(255,255,255,.12)'); g.addColorStop(0.3, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(0,0,0,.22)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    };
    const drawDesign = (W, H) => {
      const d = imgs[mode];
      ctx.fillStyle = '#05060a'; ctx.fillRect(0, 0, W, H);
      if (!d || !d.im.complete || !d.im.naturalWidth) return;
      const k = d.im.naturalWidth / 1254;
      let [sx, sy, sw, sh] = d.crop.map(v => v * k);
      // Fit the crop to the panel shape, then drift slowly like a living display.
      const want = sw / RATIO;
      if (want < sh) { sy += (sh - want) / 2; sh = want; } else { const ww = sh * RATIO; sx += (sw - ww) / 2; sw = ww; }
      const zoom = 1.06 + 0.03 * Math.sin(t * 0.35);
      const zw = sw / zoom, zh = sh / zoom;
      const px = sx + (sw - zw) * (0.5 + 0.45 * Math.sin(t * 0.22));
      const py = sy + (sh - zh) * (0.5 + 0.45 * Math.cos(t * 0.17));
      ctx.filter = 'saturate(1.25) brightness(1.08)';
      ctx.drawImage(d.im, px, py, zw, zh, 0, 0, W, H);
      ctx.filter = 'none';
      // Soft bloom pass so the colors glow like lit LEDs.
      if ('filter' in ctx) {
        ctx.filter = `blur(${Math.round(W / 140)}px)`;
        ctx.globalCompositeOperation = 'lighter';
        ctx.globalAlpha = 0.28;
        ctx.drawImage(d.im, px, py, zw, zh, 0, 0, W, H);
        ctx.filter = 'none';
      }
    };
    const drawText = (W, H, dt) => {
      ctx.fillStyle = '#05060a'; ctx.fillRect(0, 0, W, H);
      const txt = (input.value.trim() || 'USA').toUpperCase();
      const fs = Math.round(H * 0.62);
      ctx.font = `${fs}px "Bebas Neue", Impact, sans-serif`;
      ctx.textBaseline = 'middle';
      const parts = [...txt + '   ★   '];
      const widths = parts.map(ch => ctx.measureText(ch).width + fs * 0.06);
      const total = widths.reduce((a, b) => a + b, 0);
      offset = (offset + dt * Number(speedEl.value) * W * 0.035) % total;
      ctx.shadowBlur = fs * 0.25;
      for (let rep = 0; rep < 3; rep++) {
        let x = -offset + rep * total, n = 0;
        parts.forEach((ch, i) => {
          if (x + widths[i] > 0 && x < W) {
            const c = color === 'rwb' ? ['#ff2d45', '#ffffff', '#3d7bff'][n % 3] : color;
            ctx.fillStyle = c; ctx.shadowColor = c;
            ctx.fillText(ch, x, H * 0.54);
          }
          if (ch !== ' ') n++;
          x += widths[i];
        });
      }
      ctx.shadowBlur = 0;
    };
    const frame = now => {
      if (!running) return;
      const dt = Math.min(0.05, (now - (last || now)) / 1000);
      last = now; t += dt;
      const dpr = size(); buildMesh(dpr);
      const W = canvas.width, H = canvas.height;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      if (mode === 'text') drawText(W, H, dt); else drawDesign(W, H);
      finish(W, H);
      requestAnimationFrame(frame);
    };
    const start = () => { if (!running) { running = true; last = 0; requestAnimationFrame(frame); } };
    const stop = () => { running = false; };

    const pick = btn => {
      mode = btn.dataset.lpDesign;
      designs.forEach(x => x.setAttribute('aria-pressed', String(x === btn)));
      textbox.hidden = mode !== 'text';
      load(btn);
    };
    designs.forEach(b => b.addEventListener('click', () => pick(b)));
    qa('[data-lp-color]').forEach(b => b.addEventListener('click', () => {
      color = b.dataset.lpColor;
      qa('[data-lp-color]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    }));
    qa('[data-lp-phrase]').forEach(b => b.addEventListener('click', () => { input.value = b.textContent; offset = 0; }));
    if (designs[0]) pick(designs[0]);
    // Warm up the other designs once the panel is close to the screen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        if (en.isIntersecting) { designs.forEach(load); start(); } else stop();
      }, { rootMargin: '200px' }).observe(canvas);
    } else { designs.forEach(load); start(); }
    window.addEventListener('resize', () => { canvas.width = 0; });
  }
  // Sticky bar on phones once the buy box scrolls away.
  const sticky = q('[data-lp-sticky]');
  const buy = q('#lp-buy');
  if (sticky && buy && 'IntersectionObserver' in window && matchMedia('(max-width: 899px)').matches) {
    new IntersectionObserver(([en]) => { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }).observe(buy);
  }
})();
